import { render, staticRenderFns } from "./quiz-format.html?vue&type=template&id=515c68f4&scoped=true&external"
import script from "./quiz-format.js?vue&type=script&lang=js&external"
export * from "./quiz-format.js?vue&type=script&lang=js&external"
import style0 from "./quiz-format.css?vue&type=style&index=0&id=515c68f4&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515c68f4",
  null
  
)

export default component.exports